<template>
  <div>
    <div class="card">
      <div class="card-top">
        <div class="card-title">
          הצטרף מס׳ לא מוכר
        </div>
        <div class="card-text">
          לחיצה על דיווח תעצור את הודעות התזרים עד שהצוות שלנו יחקור את העניין.
        </div>
      </div>
      <div class="buttons">
        <card-button :action="() => reportGroupJoin()" :title="'דיווח על מס׳ לא מוכר'" :cardStyle="'primary'"/>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import Segment from '../../../../Segment';
import CardButton from '../../../../base-components/card-parts/CardButton.vue';

export default {
  name: 'SuspiciousGroupJoinCard',
  components: {
    CardButton,
  },
  computed: {
  },
  methods: {
    ...mapActions('suspiciousGroupJoin', ['reportSuspiciousGroupJoin']),
    async reportGroupJoin() {
      Segment.trackUserInteraction('ReportSuspiciousGroupJoinClicked', {});
      await this.reportSuspiciousGroupJoin();
    },
  },
};
</script>


<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .open-card {
    padding: 8px 0px 17px 0px;
  }

  .card {
    @include card;

    .card-top {
      padding: 21px 32px 0px 32px;

      .card-title {
        @include card-title;
        margin-bottom: 12px;
      }

      .card-text {
        font-size: 16px;
        line-height: 1.5;
        font-family: SimplerPro;
      }
    }

    .buttons {
      padding: 21px 30px 34px 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/suspicious-group-join/SuspiciousGroupJoinQuestion.vue